import type { Logger } from './abstractLogger';
import DevelopmentLogger from './developmentLogger';
import ProductionLogger from './productionLogger';

const logger: Logger =
  process.env.NODE_ENV === 'development'
    ? new DevelopmentLogger()
    : new ProductionLogger();

export default logger;
